import { ButtonBase, Typography } from '@mui/material';

type StatTileProps = {
  value: string;
  label: string;
  tone?: 'default' | 'error' | 'warning';
  isActive?: boolean;
  onClick?: () => void;
};

const StatTile = ({ value, label, tone = 'default', isActive = false, onClick }: StatTileProps) => (
  <ButtonBase
    component={onClick ? 'button' : 'div'}
    disabled={!onClick}
    onClick={onClick}
    aria-pressed={onClick ? isActive : undefined}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      minWidth: 96,
      padding: '8px 12px',
      border: 1,
      borderColor: isActive ? 'primary.main' : 'border.default',
      borderRadius: 1,
      boxShadow: isActive ? theme => `inset 0 0 0 1px ${theme.palette.primary.main}` : 'none',
      backgroundColor: 'background.paper',
      textAlign: 'left',
      '&.Mui-disabled': { pointerEvents: 'none' },
    }}
  >
    <Typography
      variant="h4"
      component="b"
      sx={{
        fontVariantNumeric: 'tabular-nums',
        fontWeight: 600,
        color: tone === 'default' ? 'text.primary' : `${tone}.main`,
      }}
    >
      {value}
    </Typography>
    <Typography variant="body2" color="text.secondary" component="span">
      {label}
    </Typography>
  </ButtonBase>
);

export default StatTile;
